import { featureArticles } from "@/mocks/guaNews";

export default function FeatureArticles() {
  const [first, ...rest] = featureArticles;
  return (
    <section id="featured" className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h4 className="text-sm font-semibold text-accent-700">
              <a href="#featured" className="inline-flex items-center gap-1.5">
                <i className="ri-article-line text-base"></i>
                In Depth
              </a>
            </h4>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">深度图文 · 不只标题</h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
              除了速览，我们也会把一个话题聊深一层，从现象到逻辑，让你吃瓜之外看懂门道。
            </p>
          </div>
        </div>

        <div className="mt-7 grid gap-5 lg:grid-cols-[1.2fr_0.8fr]">
          {/* lead */}
          <a href="#featured" className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-inset ring-background-200/70">
            <div className="relative overflow-hidden">
              <img src={first.image} alt={first.title} className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-72" />
              <span className={`absolute left-4 top-4 whitespace-nowrap rounded-md px-2.5 py-1 text-xs font-semibold ${first.accent}`}>
                {first.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <h3 className="font-heading text-xl font-bold leading-7 text-foreground-950 group-hover:text-primary-700 md:text-2xl">
                {first.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{first.excerpt}</p>
              <div className="mt-5 flex items-center justify-between border-t border-background-200/70 pt-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                  <i className="ri-user-3-line"></i>
                  {first.author}
                </span>
                <span className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-calendar-line"></i>{first.date}</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-eye-line"></i>{first.reads}</span>
                </span>
              </div>
            </div>
          </a>

          {/* side cards */}
          <div className="space-y-5">
            {rest.map((f) => (
              <a key={f.title} href="#featured" className="group flex gap-4 overflow-hidden rounded-2xl bg-background-50 p-3 ring-1 ring-inset ring-background-200/70">
                <div className="relative h-28 w-28 shrink-0 overflow-hidden rounded-xl">
                  <img src={f.image} alt={f.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <span className={`absolute left-2 top-2 whitespace-nowrap rounded px-1.5 py-0.5 text-[10px] font-semibold ${f.accent}`}>
                    {f.tag}
                  </span>
                </div>
                <div className="flex min-w-0 flex-col justify-center">
                  <h3 className="text-[15px] font-bold leading-6 text-foreground-950 group-hover:text-primary-700">{f.title}</h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600">{f.excerpt}</p>
                  <span className="mt-2 inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500">
                    <i className="ri-user-3-line"></i>
                    {f.author} · {f.reads}
                  </span>
                </div>
              </a>
            ))}
            <a
              href="#faq"
              className="group flex items-center justify-between rounded-2xl bg-primary-500 p-5 text-background-50 transition-colors hover:bg-primary-600"
            >
              <div>
                <p className="font-heading text-base font-bold">关于吃瓜合集，你有疑问？</p>
                <p className="mt-1 text-xs text-background-50/85">常见问题与说明都在这里，点开查看。</p>
              </div>
              <i className="ri-arrow-right-circle-line text-2xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}